<template>
     <div class="footer">

<div class="content clearfix">

  <div class="footer_form">
    <div class="footer_logo">
      <img src="../assets/images/logo.png" alt="">
    </div>
    <div class="form">
        <h6>联系我们</h6>
        <div class="input">
          <input type="text" v-model="formData.companyName" placeholder="公司名称">
        </div>
        <div class="input">
          <input type="text" v-model="formData.callName" placeholder="姓名">
        </div>
        <div class="input">
          <input type="text" v-model="formData.phone" placeholder="联系方式">
        </div>
        <div class="input">
          <input type="text" v-model="formData.businessName" placeholder="业务形式">
        </div>
        <div class="form_btn" @click="handleSubmit" :class="{ 'disabled': submitting }">
          <span>{{ submitting ? '提交中...' : '提交' }}</span>
          <img src="../assets/images/icon_small_right.png" alt="">
        </div>
        <div class="clearfix"></div>
    </div>
  </div>
  <div class="footer_right">

      <div class="footer_right_nav">
        <div class="footer_right_nav_item">
          <a @click="goToAbout" class="t" style="cursor: pointer;">明晟之道</a>
          <ul>
            <li><a href="javascript:void(0);" @click="goToAboutCompany" style="cursor: pointer;">公司介绍</a></li>
            <li><a href="javascript:void(0);" @click="goToAboutChairman" style="cursor: pointer;">董事长寄语</a></li>
            <!-- <li><a href="javascript:void(0);">品牌故事</a></li> -->
            <li><a href="javascript:void(0);" @click="goToAboutMission" style="cursor: pointer;">使命愿景</a></li>
            <li><a href="javascript:void(0);" @click="goToAboutHistory" style="cursor: pointer;">发展历程</a></li>
            <!-- <li><a href="javascript:void(0);">集团沿革</a></li> -->
            <!-- <li><a href="javascript:void(0);">董事及高级管理层</a></li> -->
            <!-- <li><a href="javascript:void(0);">创新与未来战略</a></li> -->
          </ul>
        </div>
        <div class="footer_right_nav_item">
          <a @click="goToProduct"  class="t" style="cursor: pointer;">产品与服务</a>
          <ul>
            <!-- <li><a href="javascript:void(0);" @click="goToProduct">产品</a></li> -->
            <!-- <li><a href="javascript:void(0);">服务中心</a></li> -->
            <li><a href="javascript:void(0);" @click="goToProductOne" style="cursor: pointer;">氨法脱硫</a></li>
            <li><a href="javascript:void(0);" @click="goToProductTwo" style="cursor: pointer;">烟道插板阀</a></li>
            <li><a href="javascript:void(0);" @click="goToProductThree" style="cursor: pointer;">轮胎裂解</a></li>
            <li><a href="javascript:void(0);" @click="goToProductFour" style="cursor: pointer;">压力容器</a></li>
            <li><a href="javascript:void(0);" @click="goToProductFive" style="cursor: pointer;">工程安装</a></li>
            <li><a href="javascript:void(0);" @click="goToProductSix" style="cursor: pointer;">运维服务</a></li>
          </ul>
        </div>
        <!-- <div class="footer_right_nav_item">
          <a href="javascript:void(0);" class="t">解决方案</a>
          <ul>
            <li><a href="javascript:void(0);">煤化工行业脱硫解决方案</a></li>
            <li><a href="javascript:void(0);">钢铁行业脱硫解决方案</a></li>
            <li><a href="javascript:void(0);">热电厂脱硫解决方案</a></li>
            <li><a href="javascript:void(0);">碳素厂脱硫解决方案</a></li>
            <li><a href="javascript:void(0);">焦化行业脱硫解决方案</a></li>
            <li><a href="javascript:void(0);">电解铝行业脱硫解决方案</a></li>
          </ul>
        </div> -->
        <div class="footer_right_nav_item">
          <a @click="goToCase" class="t" style="cursor: pointer;">明晟业绩</a>
          <ul>
            <!-- <li><a @click="goToCase" class="" style="cursor: pointer;">百日工程</a></li>
            <li><a @click="goToCase" class="" style="cursor: pointer;">脱硫脱硝</a></li>
            <li><a @click="goToCase" class="" style="cursor: pointer;">项目安装</a></li>
            <li><a @click="goToCase" class="" style="cursor: pointer;">项目运维</a></li>
          -->
          <li><a href="javascript:void(0);" @click="goToCaseType('1')" style="cursor: pointer;">化工</a></li>
          <li><a href="javascript:void(0);" @click="goToCaseType('2')" style="cursor: pointer;">钢铁</a></li>
          <li><a href="javascript:void(0);" @click="goToCaseType('3')" style="cursor: pointer;">碳素</a></li>
          <li><a href="javascript:void(0);" @click="goToCaseType('4')" style="cursor: pointer;">焦化</a></li>
          <li><a href="javascript:void(0);" @click="goToCaseType('5')" style="cursor: pointer;">造纸</a></li>
          <li><a href="javascript:void(0);" @click="goToCaseType('6')" style="cursor: pointer;">火力发电/热点联产</a></li>
          </ul>
        </div>
        <div class="footer_right_nav_item">
          <a @click="goToNews" class="t" style="cursor: pointer;">媒体中心</a>
          <ul>
            <li><a href="javascript:void(0);" @click="goToNews('1')" style="cursor: pointer;">集团动态</a></li>
            <li><a href="javascript:void(0);" @click="goToNews('2')" style="cursor: pointer;">行业动态</a></li>
            <li><a href="javascript:void(0);" @click="goToNews('3')" style="cursor: pointer;">政策解读</a></li>
            <!-- <li><a href="javascript:void(0);" @click="goToNews('4')" style="cursor: pointer;">信息公开</a></li> -->
          </ul>
        </div>
        <div class="footer_right_nav_item">
          <a @click="goToSustainable" class="t" style="cursor: pointer;">可持续发展</a>
          <ul>
            <li><a href="javascript:void(0);" @click="goToSustainableMission" style="cursor: pointer;">目标理念</a></li>
            <li><a href="javascript:void(0);" @click="goToSustainableResults" style="cursor: pointer;">关键成果</a></li>
            <!-- <li><a href="javascript:void(0);">明晟生态研究院</a></li> -->
            <!-- <li><a href="javascript:void(0);">2025可持续发展报告</a></li> -->
          </ul>
        </div>
        <div class="footer_right_nav_item">
          <a @click="goToCarrer" class="t" style="cursor: pointer;">人才发展</a>
          <ul>
            <li><a href="javascript:void(0);" @click="goToCarrerCulture" style="cursor: pointer;">企业文化</a></li>
            <li><a href="javascript:void(0);" @click="goToCarrerValues" style="cursor: pointer;">人才价值观</a></li>
            <!-- <li><a href="javascript:void(0);">明晟之星</a></li> -->
            <li><a @click="goToPersonnel" style="cursor: pointer;">就业机会</a></li>
          </ul>
        </div>


      </div>
      <div class="footer_right_bom">
          <div class="footer_right_code">
            <div class="footer_right_code_item">
              <img src="../assets/images/code_71.png" alt="">
              <p>明晟环保视频号</p>
            </div>
            <div class="footer_right_code_item">
              <img src="../assets/images/code_73.png" alt="">
              <p>明晟环保抖音</p>
            </div>
            <div class="footer_right_code_item">
              <img src="../assets/images/code_75.png" alt="">
              <p>明晟环保公众号</p>
            </div>
            <div class="footer_right_code_item">
              <img src="../assets/images/code_77.png" alt="">
              <p>Facebook</p>
            </div>
            <div class="footer_right_code_item">
              <img src="../assets/images/code_79.png" alt="">
              <p>Linkedin</p>
            </div>
            <div class="footer_right_code_item">
              <img src="../assets/images/code_81.png" alt="">
              <p>TikTok</p>
            </div>
            <div class="footer_right_code_item">
              <img src="../assets/images/code_83.png" alt="">
              <p>YouTube</p>
            </div>


          </div>
          <div class="footer_right_text">
            <p>
              <span>地址:</span>
              <font>山东省济南市章丘区龙山产业园3号路</font>
            </p>
            <p>
              <span>国内:</span>
              <font>+86 185 6023 8118</font>
            </p>
            <p>
              <span>海外:</span>
              <font>+86 156 6577 1608</font>
            </p>
            <p>
              <span>采购:</span>
              <font>0531-83201861</font>
            </p>
            <p>
              <span>邮箱:</span>
              <font>Brand@sd-ms.cn</font>
            </p>
          </div>
      </div>

  </div>

</div>
<div class="footer_copyright">
  Copyright © 2025 MIRSHINE All Rights Reserved 明晟环保所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">鲁ICP备19004349号</a>      山东明晟环保科技有限公司
</div>
<div class="slide_right">
    <div class="slide_item slide_item_phone">
      <img src="../assets/images/icon_phone.png" alt="">
      <div class="slide_item_tooltip slide_item_tooltip_phone">
        <span>业务咨询热线</span>
        <span>185 6023 8118</span>
      </div>
    </div>
    <div class="slide_item slide_item_email">
      <img src="../assets/images/icon_email.png" alt="">
      <div class="slide_item_tooltip slide_item_tooltip_email">
        <span>业务联系邮箱</span>
        <span>Brand@sd-ms.cn</span>
      </div>
    </div>
    <div class="slide_item slide_item_code">
      <img src="../assets/images/icon_code.png" alt="">
      <div class="slide_item_tooltip slide_item_tooltip_code">
        <img src="../assets/images/kefu.jpg" alt="">
        <p>扫码联系客服</p>
      </div>
    </div>
    <!-- <div class="slide_item slide_item_top">
      <img src="../assets/images/icon_return_top.png" alt="">
    </div> -->
</div>
</div>

  </template>
  
  <script>
  import { saveCallUs } from '@/api/callUs'

  export default {
    name: 'footer',
    props: {

    },
    data() {
      return {
        formData: {
          companyName: '',
          callName: '',
          phone: '',
          businessName: ''
        },
        submitting: false
      }
    },
    methods: {
      // 导航跳转方法
      goToAbout() {
        this.$router.push('/about')
      },
      goToAboutCompany() {
        this.$router.push({
          path: '/about',
          hash: '#about_one'
        })
      },
      goToAboutChairman() {
        this.$router.push({
          path: '/about',
          hash: '#about_two'
        })
      },
      goToAboutHistory() {
        this.$router.push({
          path: '/about',
          hash: '#about_four'
        })
      },
      goToAboutMission() {
        this.$router.push({
          path: '/about',
          hash: '#about_three'
        })
      },
      goToCase() {
        this.$router.push('/case')
      },
      goToCaseType(type) {
        // 携带 type 参数跳转到业绩页面，不影响现有 CaseView 的路由解析逻辑
        this.$router.push({
          path: '/case',
          query: { type }
        })
      },
      goToNews(type) {
        const query = { page: 1 }
        if (type) {
          query.type = type
        }
        this.$router.push({
          path: '/news',
          query
        })
      },
      goToSustainable() {
        this.$router.push('/sustainable')
      },
      goToSustainableMission() {
        this.$router.push({
          path: '/sustainable',
          hash: '#kcxfz_one'
        })
      },
      goToSustainableResults() {
        this.$router.push({
          path: '/sustainable',
          hash: '#kcxfz_two'
        })
      },
      goToCarrer() {
        this.$router.push('/carrer')
      },
      goToCarrerCulture() {
        this.$router.push({
          path: '/carrer',
          hash: '#carrer_one'
        })
      },
      goToCarrerValues() {
        this.$router.push({
          path: '/carrer',
          hash: '#carrer_three'
        })
      },
      goToPersonnel() {
        this.$router.push('/personnel')
      },
      goToProduct(){
        this.$router.push('/product')
      },
      goToProductOne() {
        this.$router.push('/productOne')
      },
      goToProductTwo() {
        this.$router.push('/productTwo')
      },
      goToProductThree() {
        this.$router.push('/productThree')
      },
      goToProductFour() {
        this.$router.push('/productFour')
      },
      goToProductFive() {
        this.$router.push('/productFive')
      },
      goToProductSix() {
        this.$router.push('/productSix')
      },
      // 表单验证
      validateForm() {
        if (!this.formData.companyName || !this.formData.companyName.trim()) {
          this.$modal.error('请输入公司名称', '提示')
          return false
        }
        if (!this.formData.callName || !this.formData.callName.trim()) {
          this.$modal.error('请输入姓名', '提示')
          return false
        }
        if (!this.formData.phone || !this.formData.phone.trim()) {
          this.$modal.error('请输入联系方式', '提示')
          return false
        }
        if (!this.formData.businessName || !this.formData.businessName.trim()) {
          this.$modal.error('请输入业务形式', '提示')
          return false
        }
        // 简单的手机号验证（可选）
        const phoneReg = /^1[3-9]\d{9}$/
        if (!phoneReg.test(this.formData.phone.trim()) && !/^[\d\-\+\(\)\s]+$/.test(this.formData.phone.trim())) {
          // 如果不是标准手机号格式，至少检查是否包含数字
          if (!/\d/.test(this.formData.phone.trim())) {
            this.$modal.error('请输入有效的联系方式', '提示')
            return false
          }
        }
        return true
      },
      // 提交表单
      async handleSubmit() {
        if (this.submitting) {
          return
        }

        // 表单验证
        if (!this.validateForm()) {
          return
        }

        this.submitting = true

        try {
          const params = {
            companyName: this.formData.companyName.trim(),
            callName: this.formData.callName.trim(),
            phone: this.formData.phone.trim(),
            businessName: this.formData.businessName.trim()
          }

          const response = await saveCallUs(params)

          // 提交成功
          this.$modal.success('提交成功，我们会尽快与您联系！', '成功')

          // 清空表单
          this.formData = {
            companyName: '',
            callName: '',
            phone: '',
            businessName: ''
          }
        } catch (error) {
          // 提交失败
          const errorMsg = error.message || '提交失败，请稍后重试'
          this.$modal.error(errorMsg, '错误')
        } finally {
          this.submitting = false
        }
      }
    }
  }
  </script>
  
  
  